module.exports = __webpack_public_path__ + "media/images/riders/small/JURE_ZABJEK-acf52f2f5bf8f52beec1697aac9aa53a.png";